import { api } from '@/core/http/apiClient';
import type {
  AccountantReportSettings,
  AccountantReportView,
  CompanyContactOptions,
  CompanyContactsView,
  CompanyInfoSettings,
  CompanyReportOptions,
  DirectorsReportSignatories,
  DirectorsReportView,
  ReportNoteSection,
  ReportNoteTextInput,
  ReportNoteTextRow,
  SaveCompanyContactPayload,
  SaveCompanyContactResponse,
} from '@/core/models/report-settings.models';

export const reportSettingsService = {
  getOptions: () => api.get<CompanyReportOptions>('ReportSettings/getOptions'),

  // ---- Company info ----

  getCompanyInfo: (clientId: string) => api.get<CompanyInfoSettings>(`ReportSettings/getCompanyInfo/${clientId}`),

  saveCompanyInfo: (payload: CompanyInfoSettings) =>
    api.post<CompanyInfoSettings>('ReportSettings/saveCompanyInfo', payload),

  // ---- Company contacts ----

  getCompanyContacts: (clientId: string) =>
    api.get<CompanyContactsView>(`ReportSettings/getCompanyContacts/${clientId}`),

  saveContactOptions: (payload: CompanyContactOptions) =>
    api.post<CompanyContactOptions>('ReportSettings/saveContactOptions', payload),

  saveCompanyContact: (payload: SaveCompanyContactPayload) =>
    api.post<SaveCompanyContactResponse>('ReportSettings/saveCompanyContact', payload),

  deleteCompanyContacts: (ids: string[]) => api.post<boolean>('ReportSettings/deleteCompanyContacts', ids),

  selectCompanyContacts: (clientId: string, contactType: number, ids: string[], isSelected: boolean) =>
    api.post<boolean>('ReportSettings/selectCompanyContacts', { clientId, contactType, ids, isSelected }),

  // ---- Director's report ----

  getDirectorsReport: (clientId: string) =>
    api.get<DirectorsReportView>(`ReportSettings/getDirectorsReport/${clientId}`),

  saveSignatories: (payload: DirectorsReportSignatories) =>
    api.post<DirectorsReportSignatories>('ReportSettings/saveSignatories', payload),

  // ---- Accountant's report ----

  getAccountantReport: (clientId: string) =>
    api.get<AccountantReportView>(`ReportSettings/getAccountantReport/${clientId}`),

  saveAccountantReport: (payload: AccountantReportSettings) =>
    api.post<AccountantReportSettings>('ReportSettings/saveAccountantReport', payload),

  // ---- Notes and policies ----

  getReportNoteTexts: (clientId: string, section: ReportNoteSection) =>
    api.get<ReportNoteTextRow[]>(`ReportSettings/getReportNoteTexts/${clientId}/${section}`),

  saveReportNoteTexts: (clientId: string, section: ReportNoteSection, notes: ReportNoteTextInput[]) =>
    api.post<ReportNoteTextRow[]>('ReportSettings/saveReportNoteTexts', { clientId, section, notes }),
};
